import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Token } from '@/config'

interface CustomTokenEntry {
  chainId: number
  token: Token
}

interface CustomTokensStore {
  entries: CustomTokenEntry[]
  addToken: (chainId: number, token: Token) => void
  getTokens: (chainId: number) => Token[]
}

export const useCustomTokensStore = create<CustomTokensStore>()(
  persist(
    (set, get) => ({
      entries: [],
      addToken: (chainId, token) => {
        const exists = get().entries.some(
          (e) => e.chainId === chainId && e.token.address.toLowerCase() === token.address.toLowerCase()
        )
        if (exists) return
        set((state) => ({ entries: [...state.entries, { chainId, token }] }))
      },
      getTokens: (chainId) =>
        get().entries.filter((e) => e.chainId === chainId).map((e) => e.token),
    }),
    { name: 'axonswap-custom-tokens' }
  )
)
